import { IconExpand, IconCollapse } from '@ui/src';
import FeeItem from './fee-item';
import { FeeTypeEnum, FeeSubTypeEnum } from '../../hoc/fees/types';
import { FeeBlockTypes } from './types';

import cn from './fees.module.css';

const getFeeTypeName = (type: string) => {
  let typeName;

  switch (type) {
    case FeeTypeEnum.INTERNAL:
      typeName = 'Internal';
      break;
    case FeeTypeEnum.MANUAL:
      typeName = 'Manual';
      break;
    case FeeTypeEnum.REGULAR:
      typeName = 'Regular';
      break;
    case FeeTypeEnum.TRANSACTION:
      typeName = 'Transaction';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

const getSubTypeName = (subType: string) => {
  let subTypeName;

  switch (subType) {
    case FeeSubTypeEnum.HIGH_BALANCE:
      subTypeName = 'High-Balance fee';
      break;
    case FeeSubTypeEnum.INACTIVITY:
      subTypeName = 'Account inactivity fee';
      break;
    case FeeSubTypeEnum.REGULAR:
      subTypeName = 'Regular package fee';
      break;
    default:
      subTypeName = subType;
      break;
  }

  return subTypeName;
};

const FeeBlock = ({
  collapsed,
  item,
  setCollapsed,
  paymentTypes,
}: FeeBlockTypes) => {
  let title;

  if (item.type === FeeTypeEnum.TRANSACTION) {
    title = `${getFeeTypeName(item.type)} ${
      paymentTypes?.find((type) => type.paymentType === item.subType)?.name ||
      ''
    }`;
  } else {
    title = `${getFeeTypeName(item.type)} ${
      item?.subType ? getSubTypeName(item?.subType) : 'fee'
    }`;
  }

  return (
    <div className={cn.feeBlock}>
      <div className={cn.feeBlockTop}>
        <div className={cn.feeBlockTitle}>{title}</div>
        <button
          type="button"
          className={cn.collapseButton}
          onClick={() => setCollapsed(`${item.type}-${item.subType}`)}
        >
          {collapsed ? (
            <IconExpand width={24} height={24} />
          ) : (
            <IconCollapse width={30} height={30} />
          )}
        </button>
      </div>
      {!collapsed &&
        item?.list?.map((fee) => (
          <FeeItem key={fee.id} title={fee.name} id={fee.id} />
        ))}
    </div>
  );
};

export default FeeBlock;
